// extracted by mini-css-extract-plugin
module.exports = {"sliderPlaylist":"playlists_sliderPlaylist__1zTNt","containerVideo":"playlists_containerVideo__UoJE-","cardVideo":"playlists_cardVideo__2cNM6"};